import { render, staticRenderFns } from "./shop-certification-stat.vue?vue&type=template&id=8a67ab08&scoped=true"
import script from "./shop-certification-stat.vue?vue&type=script&lang=js"
export * from "./shop-certification-stat.vue?vue&type=script&lang=js"
import style0 from "./shop-certification-stat.vue?vue&type=style&index=0&id=8a67ab08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a67ab08",
  null
  
)

export default component.exports